import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export const EnterpriceSolution = () => {
  return (
    <Container fluid style={{ background: "#F7F7F7" }} className="py-5">
      <Container>
        <h1 className="text-6xl text-black text-center robot">
          Enterprise Solutions!
        </h1>
        <Row className="align-items-center pt-5 divReverse ">
          <Col lg="6">
            <h1
              className="text-2xl text-center font-semibold"
              style={{ color: "#6A489C" }}
            >
              CEnterprise Solutions Customized for Your Business
            </h1>
            <br />
            <p className="text-lg" style={{ color: "#7A7979" }}>
              Need help? We exist to serve the user with the purpose of
              providing them with information. We want you to find what you’re
              looking for.
            </p>
            <br />
            <p className="text-lg" style={{ color: "#7A7979" }}>
              For any query, please contact HireCo experts for the best
              solution.Need help? We exist to serve the user with the purpose of
              providing them with information. We want you to find what you’re
              looking for. For any query, please contact HireCo experts for the
              best solution.Need help? We exist to serve the user with the
              purpose of providing them with information. We want you to find
              what you’re looking for. For any query, please contact HireCo
              experts for the best solution.Need help? We exist to serve the
              user with the purpose of providing them with information. We want
              you to find what you’re looking for. For any query, please
              contact.
            </p>
            <br />
            <p className="text-lg" style={{ color: "#7A7979" }}>
              HireCo experts for the best solution.Need help? We exist to serve
              the user with the purpose of providing them with information. We
              want you to find what you’re looking for. For any query, please
              contact HireCo experts for the best solution.
            </p>
            <Link to="/Login">
              <Button className="text-white border-rounded px-5 mt-4">
                Contact Me2Works
              </Button>
            </Link>
          </Col>
          <Col lg="6" className="webkit">
            <div className="py-3">
              <Image
                style={{ width: "80%" }}
                src={require("../../../assets/enterprise.png")}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <Row className="rrro align-items-center">
        <h2
          className="text-5xl underline text-center robot"
          style={{ color: "#6A489C" }}
        >
          What We Offer
        </h2>
        <Col lg="4" className="py-3">
          <Image
            className="w-3/4"
            src={require("../../../assets/whatweneed.png")}
          />

          {/* <Image
            className="w-3/4"
            src={require("../../../assets/whatweneed1.png")}
          /> */}

          {/* <Image
            className="w-3/4"
            src={require("../../../assets/whatweneed2.png")}
          /> */}
        </Col>
        <Col lg="8">
          <Container>
            <div>
              <br />
              <p className="text-xl font-semibold">Discovery Call</p>
              <p className="text-xl" style={{ color: "#7A7979" }}>
                A simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever
              </p>
              <br />
              <p className="text-xl font-semibold">Turnkey Solution</p>
              <p className="text-xl" style={{ color: "#7A7979" }}>
                A simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s, when avn unknown printer took a galley of type
                and scrambled it to make a type specimen book. It has survived
              </p>
              <br />
              <p className="text-xl font-semibold">Future-Proof Solutions</p>
              <p className="text-xl" style={{ color: "#7A7979" }}>
                A simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the indust
              </p>
              <br />
              <p className="text-xl font-semibold">Future-Proof Solutions</p>
              <p className="text-xl" style={{ color: "#7A7979" }}>
                A simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the indust
              </p>
              <br />
              <p className="text-xl font-semibold">
                Dedication Account Management
              </p>
              <p className="text-xl" style={{ color: "#7A7979" }}>
                A simply dummy text of the printing and typesetting industry.
              </p>
            </div>
          </Container>
        </Col>
        <Col lg="4" className="py-3">
          <Image
            className="w-3/4"
            src={require("../../../assets/whatweneed1.png")}
          />
        </Col>
        <Col lg="8">
          <Container>
            <br />
            <p className="text-xl font-semibold">
              Worker Classification & Compliance Service
            </p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard
            </p>
            <br />
            <p className="text-xl font-semibold">
              Advanced Account Monitioring
            </p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s,
            </p>
            <br />
            <p className="text-xl font-semibold">Custom Contracts</p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
            </p>
            <br />
            <p className="text-xl font-semibold">Support With Posting Jobs</p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum
            </p>
          </Container>
        </Col>
        <Col lg="4" className="py-3">
          <Image
            className="w-3/4"
            src={require("../../../assets/whatweneed2.png")}
          />
        </Col>
        <Col lg="8">
          <Container>
            <br />
            <p className="text-xl font-semibold">Talent Filtering</p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when avn unknown printer took a galley of type
            </p>
            <br />
            <p className="text-xl font-semibold">
              Verified Freelancer Profiles
            </p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s,
            </p>
            <br />
            <p className="text-xl font-semibold">
              Guidance With Selecting Freelancer
            </p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
            </p>
            <br />
            <p className="text-xl font-semibold">
              Customizable Onboarding Process
            </p>
            <p className="text-xl" style={{ color: "#7A7979" }}>
              A simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when avn unknown printer took a galley of type
            </p>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};
